export const InitiatedListData =[
  {
    disputeId: "DSP-1001",
    id:1,
    referenceNo: "REF-894123",
    customerName: "Aarav Sharma",
    accountNumber: "0123456789",
    branchName: "New Baneshwor",
    disputeType: "ATM Withdrawal Issue",
    transactionDate: "2025-10-22",
    initiatedDate: "2025-10-24",
    amount: 25000,
    status: "Initiated",
    remarks: "Customer reported double debit issue",
    createdBy: "admin01",
  },
  {
    disputeId: "DSP-1002",
    id:2,
    referenceNo: "REF-894124",
    customerName: "Sita Rai",
    accountNumber: "9876543210",
    branchName: "Kalimati",
    disputeType: "POS Transaction Failure",
    transactionDate: "2025-10-20",
    initiatedDate: "2025-10-25",
    amount: 8500,
    status: "Initiated",
    remarks: "Customer charged but merchant not credited",
    createdBy: "officer02",
  },
  {
    disputeId: "DSP-1003",
    id:3,
    referenceNo: "REF-894125",
    customerName: "Prakash Thapa",
    accountNumber: "5566778899",
    branchName: "Tripureshwor",
    disputeType: "Fund Transfer Delay",
    transactionDate: "2025-10-21",
    initiatedDate: "2025-10-26",
    amount: 15000,
    status: "Initiated",
    remarks: "Transfer stuck between banks",
    createdBy: "officer01",
  },
  {
    disputeId: "DSP-1004",
    id:4,
    referenceNo: "REF-894126",
    customerName: "Nisha Shrestha",
    accountNumber: "4455667788",
    branchName: "Jawalakhel",
    disputeType: "UPI Transaction Issue",
    transactionDate: "2025-10-23",
    initiatedDate: "2025-10-27",
    amount: 3000,
    status: "Initiated",
    remarks: "Transaction failed but amount debited",
    createdBy: "admin02",
  },
  {
    disputeId: "DSP-1005",
    id:5,
    referenceNo: "REF-894127",
    customerName: "Bibek Karki",
    accountNumber: "9988776655",
    branchName: "Thamel",
    disputeType: "Cheque Cleared Incorrectly",
    transactionDate: "2025-10-19",
    initiatedDate: "2025-10-25",
    amount: 50000,
    status: "Initiated",
    remarks: "Wrong account credited",
    createdBy: "officer03",
  },
]